/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptions, FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptionsFromJSONTyped, FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptionsToJSON, } from './FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptions';
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptionsFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptionsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptions(json)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptionsToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptionsToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptions(value)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptions.js.map